const DEFAULT_API_URL = "https://juza-pro-vercel.vercel.app";
const SERVER_BASE_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(/\/+$/, "");

export { SERVER_BASE_URL };
